// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2hYYS","radioRow":"SimpleQuestionBuilderModal_radioRow__3aSPh"};